module.exports = __webpack_public_path__ + "static/scale-model-of-the-frick-pittsburgh-in-pittsburgh-pennsylvania-39b39ab3eb04836b2acdaad30d4e679f.png";